











import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { IOrderItemParamDto } from "@/types/interface/IOrderItemParamDto";
import USD from "./USD.vue";

@Component({
  name: "OrderItemParams",
  components: {
    USD
  }
})
export default class OrderItemParams extends Vue {
  @Prop({ default: { params: [] } }) item!: IOrderItemParamDto[];
}
